<c-row class="mb-4 d-print-none">
  <div class="fs-2 fw-semibold">{{ title }}</div>
  <c-breadcrumb-router />
</c-row>
